import React, { useEffect } from 'react'
import styles from './styles.module.css'
import Button from '../../components/Button'
import { IoIosAdd } from 'react-icons/io'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import Modal from './Modal'
import Table from '../../components/Table'
import { BiTrash } from 'react-icons/bi'
import Confirmation from '../../components/Confirmation/Confirmation'
import { getOrdersList, getOrderSpecs, deleteOrder } from '../../actions/orders'
import TabSelectModal from '../../components/TabSelectModal/TabSelectModal'


export default function Orders() {

  const dispatch = useDispatch()

  const { ordersList, loading, specFields, specs } = useSelector(state => state.orders)

  const [selectedItem, setSelectedItem] = useState(null)
  const [confirmation, setConfirmation] = useState(false);

  const [tab, setTab] = useState(null)
  const [selectedItemsTab, setSelectedItemsTab] = useState([])
  const [filteredTab, setFilteredTab] = useState(null)
  const [selectedTab, setSelectedTab] = useState(null)


  useEffect(() => {
    dispatch(getOrdersList())
  }, [])

  useEffect(() => {
    selectedItem && selectedItem !== 'add' && dispatch(getOrderSpecs(selectedItem?.idorder))
  }, [selectedItem])

  useEffect(() => {
    ordersList && setFilteredTab(ordersList)
  }, [ordersList])

  useEffect(() => {
    const arr = ordersList?.filter(el => selectedItemsTab?.find(item => item == el[tab]))
    setFilteredTab(arr?.length ? arr : ordersList)
  }, [selectedTab])

  const openModal = (data) => () => {
    setSelectedItem(data)
  }

  const closeModal = () => setSelectedItem(null)

  const closeSelectedTab = () => {
    setSelectedTab(null) // выпадашка для хэдеров таблички
  }
  const cleanFilters = () => {
    setSelectedTab(null)
    setSelectedItemsTab([])
    ordersList && setFilteredTab(ordersList)
  }

  const acceptConfirmation = () => {
    closeModal();
    dispatch(deleteOrder(confirmation.id));
    setConfirmation(false);
  };
  const rejectConfirmation = () => {
    setConfirmation(false);
  };

  const renderLi = (data) => {
    const { idorder, ordertitle, orderdate, ordernum } = data
    return (
      <tr >
        <td onClick={openModal(data)}>{orderdate}</td>
        <td onClick={openModal(data)}>{ordernum}</td>
        <td onClick={openModal(data)}>{ordertitle}</td>
        <td><i className={styles.trash} onClick={() => setConfirmation({ id: idorder, name: ordertitle })}><BiTrash /></i></td>
      </tr>
    )
  }
  // выпадашка для хэдеров таблички
  const setUniqArr = (arr) => {
    const uniqueValues = new Set(arr);
    const uniqueArray = [...uniqueValues];
    return uniqueArray
  }

  const getSelectTab = (tab) => () => {
    switch (tab) {
      case 'ordertitle': return (setSelectedTab(setUniqArr(ordersList?.map(el => el.ordertitle))), setTab(tab), setSelectedItemsTab([]))
      case 'orderdate': return (setSelectedTab(setUniqArr(ordersList?.map(el => el.orderdate))), setTab(tab), setSelectedItemsTab([]))
      case 'ordernum': return (setSelectedTab(setUniqArr(ordersList?.map(el => el.ordernum))), setTab(tab), setSelectedItemsTab([]))
      default:
        return []
    }
  }
  // выпадашка для хэдеров таблички

  return (
    <>
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title={`Вы уверены, что хотите удалить ${confirmation.name}?`}
          acceptConfirmation={() => acceptConfirmation(confirmation?.name)}
          rejectConfirmation={rejectConfirmation}
        />
      )}
      <div className={styles.wrapper} style={{ width: '700px', margin: '0 auto' }}>
        {selectedItem &&
          <Modal
            closeModal={closeModal}
            data={selectedItem}
            height={'430px'}
            // addMode={(!selectedItem?.name && selectedItem !== null)}
            addMode={selectedItem == 'add'}
          />
        }
        {selectedTab &&
          <TabSelectModal
            closeModal={closeSelectedTab}
            data={selectedTab}
            selectedItemsTab={selectedItemsTab}
            setSelectedItemsTab={setSelectedItemsTab}
            height={230}
          // handleChangeStudents={handleChangeStudents}
          // selectedWeekVariant={selectedWeekVariant}
          />
        }
        <h1>Приказы</h1>

        <Table className={styles.tableDis}>
          <thead>
            <tr>
              <th onClick={getSelectTab('orderdate')}>Дата</th>
              <th onClick={getSelectTab('ordernum')}>Номер</th>
              <th onClick={getSelectTab('ordertitle')}>Название приказа</th>
            </tr>
          </thead>
          <tbody>
            {filteredTab?.map(renderLi)}
          </tbody>
        </Table>

        <div style={{ display: 'flex', flexDirection: "row" }}>
          <Button
            style={{ padding: '.5rem 1.5rem', margin: '12px' }}
            onClick={openModal('add')}
          >
            <IoIosAdd size={30} />
            Добавить
          </Button>
          {!!selectedItemsTab.length &&
            <Button
              style={{ padding: '.5rem 1.5rem', margin: '12px' }}
              onClick={cleanFilters}
            >
              <IoIosAdd size={30} />
              Сбросить
            </Button>
          }
        </div>
        <div style={{ display: 'flex', flexDirection: "row", borderTop: '1px solid #ccc' }}>
          <p>Всего строк: {filteredTab?.length}</p>
        </div>
      </div>
    </>

  )
}
